jQuery(document).ready(function ($) {
          $('.cart-customlocation').addClass('nav-link');



});